import {
  Flex,
  Loader,
  Spinner,
  Tooltip,
} from '@oliasoft-open-source/react-ui-library';
import { QueryResult } from 'client/views/query/query-result/query-result';
import { LegacyRef } from 'react';
import { FaPlay } from 'react-icons/fa';
import translations from 'client/internationalization/translation-map.json';
import { useTranslation } from 'react-i18next';
import { IQuery, IQueryResult } from 'common/interfaces/query';

const containerStyle = { height: 200, alignContent: 'center', cursor: 'pointer' };
const queryContainerStyle = { overflow: 'auto', maxHeight: '200px', padding: '0' };

export const AnalyticsCardContent = ({
  ref,
  onRun,
  onFiltersUpdate,
  result: analyticsResult,
  isRunning,
}: {
  ref: LegacyRef<HTMLDivElement>;
  onRun: () => void;
  onFiltersUpdate: (filters: { [key: string]: string }) => void;
  result: { result: IQueryResult, query: IQuery };
  isRunning: boolean;
}) => {
  const { t } = useTranslation();
  const { result, query } = analyticsResult ?? {};

  const renderBody = () => {
    if (!result) {
      return (
        <div ref={ref} style={containerStyle}>
          <Tooltip
            enabled
            text={isRunning ? `${t(translations.analytic_run)}...` : t(translations.analytic_run)}
          >
            <Flex justifyContent="center">
              {isRunning ? (
                <Loader
                  theme="white"
                  width="100%"
                  height="100px"
                >
                  <Spinner dark />
                </Loader>
              ) : <FaPlay size={100} color="#ff730d" onClick={onRun} />}
            </Flex>
          </Tooltip>
        </div>
      );
    }
    return (
      <div style={queryContainerStyle}>
        <QueryResult result={result} query={query} isRunning={isRunning} setFilters={onFiltersUpdate} />
      </div>
    );
  };
  return (
    <div ref={ref}>
      {renderBody()}
    </div>
  );
};
